import React, { createContext, useContext, useEffect, useState } from "react";

interface ProjectContextType {
  projectId: string;
  setProjectId: (id: string) => void;
  projectName: string;
  setProjectName: (name: string) => void;
  projectImage: string;
  setProjectImage: (image: string) => void;
  config: any;
  setConfig: (config: any) => void;
}

const ProjectContext = createContext<ProjectContextType>({
  projectId: "",
  setProjectId: () => {},
  projectName: "",
  setProjectName: () => {},
  projectImage: "",
  setProjectImage: () => {},
  config: null,
  setConfig: () => {},
});

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {

    const [projectId, setProjectId] = useState<string>(() => {
    return localStorage.getItem("projectId") || "";
  });

  const [projectName, setProjectName] = useState<string>(() => {
    return localStorage.getItem("projectName") || "";
  });

  const [projectImage, setProjectImage] = useState<string>(() => {
    return localStorage.getItem("projectImage") || "";
  });
  const [config, setConfig] = useState<any>(() => {
    return localStorage.getItem("config") || null;
  });
  // mỗi khi state thay đổi thì lưu vào localStorage
  useEffect(() => {
    localStorage.setItem("projectId", projectId.toString());
  }, [projectId]);

  useEffect(() => {
    localStorage.setItem("projectName", projectName);
  }, [projectName]);

  useEffect(() => {
    localStorage.setItem("projectImage", projectImage);
  }, [projectImage]);
  useEffect(() => {
    localStorage.setItem("config", config);
  }, [config]);
  return (
    <ProjectContext.Provider
      value={{
        projectId,
        setProjectId,
        projectName,
        setProjectName,
        projectImage,
        setProjectImage,
        config,
        setConfig,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
